export const toKebabCase = (str: string) => {
  if (!str) return str;
  return str
    .replace(/[\W_]+/g, ' ')
    .split(/ |\B(?=[A-Z])/)
    .map(word => word.toLowerCase())
    .join('-');
};
